import type { FormEventHandler, ReactNode } from 'react';

export function TenantSettingsFormLayout({
	children,
	knowledge,
	onSubmit,
}: {
	children: ReactNode;
	knowledge?: ReactNode;
	onSubmit: FormEventHandler<HTMLFormElement>;
}) {
	return (
		<>
			<form className="user-settings-form" onSubmit={onSubmit}>
				{children}
			</form>
			{knowledge}
		</>
	);
}
